import { fromNullable } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import { emptyFragment } from '../../../../../../../../EmptyFragment';
import { T } from '../../../../../../../../Translations';
import { ExperienceResource, OfferingType } from '../../../../../../Types';
import Popover from '../../../Popover';
import AEPLabel from './AEPLabel';
import ALPLabel from './ALPLabel';
import CoachingLabel from './CoachingLabel';
import PopoverContent from './PopoverContent';
import ProgramSequenceLabel from './ProgramSequenceLabel';
import UnlicensedIcon from '../../../ExperienceCatalog/Experience/OfferingType/UnlicensedIcon';

interface Props {
  experienceResource: ExperienceResource;
}

type Content<T> = {
  icon: T;
  tooltipText: T;
};

type ProductTypeCollection = Record<OfferingType, Content<React.ReactElement>>;

const empty: Content<React.ReactElement> = {
  icon: <></>,
  tooltipText: <></>,
};

const ProductTypeWithUnLicensed: React.FC<Props> = ({ experienceResource }) => {
  const collection: ProductTypeCollection = {
    aep: {
      icon: (
        <AEPLabel>
          <UnlicensedIcon payload={experienceResource.payload} />
        </AEPLabel>
      ),
      tooltipText: <T kind="Built for busy leaders, our library..." />,
    },
    epc: {
      icon: (
        <ALPLabel>
          <UnlicensedIcon payload={experienceResource.payload} />
        </ALPLabel>
      ),
      tooltipText: <T kind="Bring the best of business school..." />,
    },
    coaching: {
      icon: (
        <CoachingLabel>
          <UnlicensedIcon payload={experienceResource.payload} />
        </CoachingLabel>
      ),
      tooltipText: <T kind="For leaders that would benefit from having a personal guide ..." />,
    },
    'program-sequence': {
      icon: (
        <ProgramSequenceLabel>
          <UnlicensedIcon payload={experienceResource.payload} />
        </ProgramSequenceLabel>
      ),
      tooltipText: (
        <T kind="Unlock your team’s potential with our purpose-built development paths..." />
      ),
    },
    'group-coaching': empty,
  };

  return fromNullable(collection[experienceResource.payload.offeringType])
    .map((offeringType) => (
      <Popover
        icon={offeringType.icon}
        content={
          <PopoverContent
            content={<div className="bg-gray-700 text-white">{offeringType.tooltipText}</div>}
          />
        }
      />
    ))
    .getOrElse(emptyFragment);
};

export default observer(ProductTypeWithUnLicensed);
